module.exports = __webpack_public_path__ + "static/media/Pass.c610a9ce.svg";